export default [
    {
        key: 'uniqueNumber',
        label: 'Boxiti',
        variant: 'align-text-center',
        sortable: true
    },
    /* {
        key: 'externalId',
        label: 'Marketplace ID',
        sortable: true
    }, */
    {
        key: 'service',
        label: 'Sales channel'
    },
    {
        key: 'address.fullName',
        label: 'Buyer',
        sortable: true
    },
    {
        // key: 'createdAt',
        key: 'fulfillmentDate',
        label: 'Date',
        sortable: true
    },
    {
        key: 'address.country.nameEn',
        label: 'Country of delivery',
        sortable: true
    },
    {
        key: 'orderParcels',
        label: 'Parcels',
    },
    {
        key: 'delivery.orderAdminDeliveryName',
        label: 'Service name',
    },
    {
        key: 'delivery.trackingNumber',
        label: 'Track number',
    },
    {
        key: 'total',
        label: 'Total',
        sortable: true
    },
    {
        key: 'currencyCode',
        label: 'Currency',
        // sortable: true,
        variant: 'column-md'
    },
    {
        key: 'actions',
        label: ''
    }
]



// WEBPACK FOOTER //
// ./src/assets/js/columns/ordersList.js